import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";
import ErrorBoundary from "components/errorBoundary/errorBoundary";
import { fetchNavbarAndFooter } from "lib/fetchers/common";
import type { PodcastsPageData } from "lib/types/podcasts";
import { PodcastsView } from "content-ui/podcasts";
import { fetchPodcastsData } from "content-ui/podcasts/fetcher";

export async function getStaticProps({ preview }) {
  const [menuItems, dato] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchPodcastsData({ preview }),
  ]);

  return {
    props: {
      dato: dato,
      __initialState: {
        sitewideOption: { ...menuItems },
      },
    },
    // we will attempt to re-generate the page:
    // - when a request comes in
    // - at most once every minute
    revalidate: 60,
  };
}

type PodcastsPageProps = {
  dato: PodcastsPageData;
};

const PodcastsPage = ({ dato }: PodcastsPageProps) => {
  const { seo } = dato;
  return (
    <>
      <Head>
        {generateNextSeo({
          canonical: buildCanonicalUrl("/podcasts"),
          openGraph: {
            title: seo.title,
            description: seo.description,
            images: [{ url: seo.image.url }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navigation />
      <ErrorBoundary>
        <PodcastsView {...dato} />
      </ErrorBoundary>
      <Footer />
    </>
  );
};

export default PodcastsPage;
